import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

class ActividadesServiceGlobal {

  getMisActividades = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/getMisActividades", payload);
  };

  getCalendario = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/getCalendarioActividades", payload);
  };

  getActividades = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/getActividades", payload);
  };

  saveActividad = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/saveActividad", payload);
  };

  completarActividad = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/completarActividad", payload);
  };

  deleteActividad = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/deleteActividad", payload);
  };

  getCatalogos = async (payload = {}) => {
    return await apiManagementService.post("/apiglobal/v1/getCatalogosActividades", payload);
  };

  buscarClientes = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/buscarClientesActividad", payload);
  };

  getDatosCliente = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/getDatosClienteActividad", payload);
  };

}

const actividadesServiceGlobalInstance = new ActividadesServiceGlobal();

export default actividadesServiceGlobalInstance;
